import {Earnings} from './earnings.model';

export class EarningsEstimate {
  miles: Earnings;
  points: Earnings;
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/reservation/points-estimate/earnings-estimate.model.ts